import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, FormControl } from '@mui/material';
import { useState, useEffect } from 'react';
import { Toolbar } from '@mui/material';
import StyledListSelection from '../StyledInputs/StyledListSelection';
import StyledTextInput from '../StyledInputs/StyledTextInput';
import StyledOutlinedButton from '../StyledButtons/StyledOutlinedButton';
import { filterSelectionSx } from '../../Utils/constants';
import { FORM_FIELD_ENTITYID, FORM_FIELD_NAME } from '../../Utils/constants/formFieldCodes';
import { TITLE_SINGULAR_ORGANIZATION } from '../../Utils/constants/titleCodes';
import { createSelectionList } from '../../Utils/helpers/listCreation';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const filterButton = { m: 1 };

const OrganizationFilter = (props) => {
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { rows, setDataView, setHasData } = props;

    const [selectedOrganizationName, setSelectedOrganizationName] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [entityIds, setEntityIds] = useState([]);
    const [selectedEntityId, setSelectedEntityId] = useState([]);

    useEffect(() => {
        createSelectionList(rows, FORM_FIELD_NAME, setOrganizationNames);
        createSelectionList(rows, FORM_FIELD_ENTITYID, setEntityIds);
        setDataView(rows);

    }, [rows]);

    const filterData = () => {
        const dataView = rows.filter((el) => {
            const hasOrganization = selectedOrganizationName.length === 0 ? true : selectedOrganizationName.includes(el.name);
            const hasEntityId = selectedEntityId.length === 0 ? true : selectedEntityId.includes(el.entityId);

            return hasOrganization && hasEntityId;
        });
        createSelectionList(dataView, FORM_FIELD_NAME, setOrganizationNames);
        createSelectionList(dataView, FORM_FIELD_ENTITYID, setEntityIds);
        setDataView(dataView);
    }

    const refreshData = () => {
        setHasData(false);
    }

    const FilterSection = () => {
        if (smallScreen) {
            return (
                <Box>
                    <Toolbar>
                        <StyledTextInput
                            sx={{ m: 1, width: 400 }}
                            label={"IDs"}
                            setSelection={setSelectedEntityId}
                            optionList={entityIds}
                        />
                    </Toolbar>
                    <Toolbar>
                        <StyledListSelection
                            sx={filterSelectionSx}
                            label={TITLE_SINGULAR_ORGANIZATION}
                            setSelection={setSelectedOrganizationName}
                            value={selectedOrganizationName}
                            optionList={organizationNames}
                        />
                    </Toolbar>
                </Box>
            )
        } else {
            return (
                <Box>
                    <Toolbar>
                        <StyledTextInput
                            sx={{ m: 1, width: 400 }}
                            label={"IDs"}
                            setSelection={setSelectedEntityId}
                            optionList={entityIds}
                        />
                        <StyledListSelection
                            sx={filterSelectionSx}
                            label={TITLE_SINGULAR_ORGANIZATION}
                            setSelection={setSelectedOrganizationName}
                            value={selectedOrganizationName}
                            optionList={organizationNames}
                        />
                    </Toolbar>
                </Box>
            )
        }
    }

    return (
        <Box>
            <FilterSection />
            <Toolbar>
                <StyledOutlinedButton
                    sx={filterButton}
                    onClick={filterData}
                >
                    Apply Filter
                </StyledOutlinedButton>
                <StyledOutlinedButton
                    sx={filterButton}
                    onClick={refreshData}
                >
                    Refresh Data
                </StyledOutlinedButton>
            </Toolbar>
        </Box>
    )
}


OrganizationFilter.propTypes = {
    rows: PropTypes.array.isRequired,
    setDataView: PropTypes.func.isRequired,
    setHasData: PropTypes.func.isRequired,
};




export default OrganizationFilter;